module.exports = __webpack_public_path__ + "img/fireworks.bd2c59f7.gif";